<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Importar Títulos a Receber do ERP
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <ng-template [ngIf]="filter">
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="importModalIntegracao" class="col-form-label">ERP</label>
                                <select class="form-control" name="importModalIntegracao" id="importModalIntegracao" 
                                    [ngModel]="filter.idIntegracao || ''" (ngModelChange)="filter.idIntegracao = $event ? $event : null"
                                    #importModalIntegracao="ngModel" required="required">
                                    <option *ngFor="let integracao of integracoes" [ngValue]="integracao.id">{{integracao.nome}}</option>
                                </select>  
                                <p class="form-text text-muted">ERP que será importado os títulos a receber</p>
                                <sgt-form-control-error
                                    *ngIf="importModalIntegracao.errors && importModalIntegracao.errors.required && importModalIntegracao.dirty"
                                    msgError="É obrigatório selecionar o ERP que deseja importar os pedidos">
                                </sgt-form-control-error>                                       
                            </div>                        
                        </div> 

                        <div class="row">
                            <div class="form-group col-12 col-md">
                                <label for="importModalCodigoIntegracao" class="col-form-label">Código ERP</label>
                                <input type="text" class="form-control" [(ngModel)]="filter.codigoIntegracao" name="importModalCodigoIntegracao" id="importModalCodigoIntegracao"
                                    #importModalcodigoIntegracao="ngModel">
                                <p class="form-text text-muted">Código do título a receber no ERP</p>
                            </div>
                            <div class="form-group col-12 col-md">
                                <label for="importModalNumeroIntegracao" class="col-form-label">Número ERP</label>
                                <input type="text" class="form-control" [(ngModel)]="filter.numeroIntegracao" name="importModalNumeroIntegracao" id="importModalNumeroIntegracao"
                                    #importModalNumeroIntegracao="ngModel">
                                <p class="form-text text-muted">Número do título a receber no ERP</p>
                            </div> 
                        </div>                           
                        <div class="row">
                            <div class="form-group col-12 col-md">
                                <label class="col-form-label" for="importModalDataEmissaoInicial">Data Emissão Inicial</label>
                                <sgt-datepicker [(ngModel)]="filter.dataEmissaoInicial" name="importModalDataEmissaoInicial" id="importModalDataEmissaoInicial"
                                    #importModalDataEmissaoInicial="ngModel" #datePickerDataEmissaoInicial [ngControl]="importModalDataEmissaoInicial">
                                </sgt-datepicker>
                                <p class="form-text text-muted">Títulos a receber emitidos a partir desta data</p>
                            </div> 
                            <div class="form-group col-12 col-md">
                                <label class="col-form-label" for="importModalDataEmissaoFinal">Data Emissao Final</label>
                                <sgt-datepicker [(ngModel)]="filter.dataEmissaoFinal" name="importModalDataEmissaoFinal" id="importModalDataEmissaoFinal"
                                    #importModalDataEmissaoFinal="ngModel" #datePickerDataEmissaoFinal [ngControl]="importModalDataEmissaoFinal">
                                </sgt-datepicker>
                                <p class="form-text text-muted">Títulos a receber emitidos até esta data</p>
                            </div>                                                     
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-md">
                                <label class="col-form-label" for="importModalDataVencimentoInicial">Data Vencimento Inicial</label>
                                <sgt-datepicker [(ngModel)]="filter.dataVencimentoInicial" name="importModalDataVencimentoInicial" id="importModalDataVencimentoInicial"
                                    #importModalDataVencimentoInicial="ngModel" #datePickerDataVencimentoInicial [ngControl]="importModalDataVencimentoInicial">
                                </sgt-datepicker>
                                <p class="form-text text-muted">Títulos a receber com vencimento a partir desta data</p>
                            </div> 
                            <div class="form-group col-12 col-md">
                                <label class="col-form-label" for="importModalDataVencimentoFinal">Data Vencimento Final</label>
                                <sgt-datepicker [(ngModel)]="filter.dataVencimentoFinal" name="importModalDataVencimentoFinal" id="importModalDataVencimentoFinal"
                                    #importModalDataVencimentoFinal="ngModel" #datePickerDataVencimentoFinal [ngControl]="importModalDataVencimentoFinal">
                                </sgt-datepicker>
                                <p class="form-text text-muted">Títulos a receber com vencimento até esta data</p>
                            </div>                                                     
                        </div>
                    </ng-template>
                </form>
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-primary" (click)="import()" [disabled]="form.invalid">
                    <i class="fas fa-download"></i> Importar
                </button>                  
            </div>            
        </div>
    </div>
</div>